module.exports = {
      id: "comm-world-cup-usage",
      viewBox: "0 0 411.122 51.012",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-world-cup",
      toString: function () {
        return this.url;
      }
    }